/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The MasterAgentSearchTag model module.
 * @module model/MasterAgentSearchTag
 * @version 1.0.0
 */
class MasterAgentSearchTag {
    /**
     * Constructs a new <code>MasterAgentSearchTag</code>.
     * @alias module:model/MasterAgentSearchTag
     */
    constructor() { 
        
        MasterAgentSearchTag.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>MasterAgentSearchTag</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/MasterAgentSearchTag} obj Optional instance to populate.
     * @return {module:model/MasterAgentSearchTag} The populated <code>MasterAgentSearchTag</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new MasterAgentSearchTag();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('order')) {
                obj['order'] = ApiClient.convertToType(data['order'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>MasterAgentSearchTag</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>MasterAgentSearchTag</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }

        return true;
    }


}



/**
 * @member {Number} id
 */
MasterAgentSearchTag.prototype['id'] = undefined;

/**
 * @member {String} name
 */
MasterAgentSearchTag.prototype['name'] = undefined;

/**
 * @member {Number} order
 */
MasterAgentSearchTag.prototype['order'] = undefined;






export default MasterAgentSearchTag;

